// Tiny global audio coordinator so only ONE audio source plays at a time
// (FM radio vs. OTT/YouTube video vs. Nethaji Bulletin TTS). Attached to
// `window` because the players live across separate module scopes/components,
// mirroring the existing window.* audio globals in this codebase and the
// mobile app's src/utils/audioCoordinator.js.

if (!window.npAudio) {
  window.npAudio = {
    stoppers: {},
    register(key, fn) {
      this.stoppers[key] = fn;
    },
    unregister(key) {
      if (this.stoppers[key]) delete this.stoppers[key];
    },
    // Stop every registered source except `exceptKey`.
    stopOthers(exceptKey) {
      Object.keys(this.stoppers).forEach((k) => {
        if (k !== exceptKey) {
          try { this.stoppers[k](); } catch (e) { /* ignore */ }
        }
      });
    },
  };
}

export const npAudio = window.npAudio;
export default npAudio;
